// Depth sort = paint by feet-baseline y, ascending, with a stable per-entity
// tiebreak so equal baselines never flicker. See research/DECISIONS.md, cross-cutting #6.
import type { Container } from "pixi.js";

export interface Depthful {
  node: Container;
  baseline: () => number;
  /** stable, unique, small integer assigned at registration for deterministic tiebreak */
  bias: number;
}

/** Higher baseline (lower on screen / nearer) => higher zIndex => painted on top. */
export function applyDepth(items: Depthful[]): void {
  for (const it of items) {
    it.node.zIndex = Math.round(it.baseline() * 16) + it.bias;
  }
}
